<mat-card>
  <app-card-header
    [title]="'QR del vehículo'"
    [subtitle]="patenteFormat"
    icono="qr_code_2"
    [botonCerrar]="true"
    (cerrar)="onClose()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <div class="qr-info">
      <span class="qr-patente">{{ patenteFormat }}</span>
    </div>
    <div #qrContainer class="qr-container"></div>
    <section class="inputs-group">
      <mat-form-field style="width: 100%">
        <mat-label>Tamaño del QR impreso</mat-label>
        <input
          matInput
          type="number"
          [(ngModel)]="tamanioCm"
          [min]="minCm"
          [max]="maxCm"
          step="0.5"
        />
        <span matSuffix>&nbsp;cm</span>
        <mat-hint>Entre {{ minCm }} y {{ maxCm }} cm</mat-hint>
      </mat-form-field>
    </section>
    <small class="qr-ayuda">
      El QR contiene la patente del vehículo. Descargá el PDF para imprimirlo.
    </small>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="onClose()">
      Cerrar
    </button>
    <button
      irxBoton="principal"
      type="button"
      [disabled]="loading"
      (click)="descargarPdf()"
    >
      <mat-icon>picture_as_pdf</mat-icon>
      Descargar PDF
    </button>
  </mat-card-actions>
</mat-card>
